import React, { useEffect, useState } from 'react';
// reactstrap components
import {
    FormGroup,
    Input,
    Row,
    Col,
    Spinner,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
} from "reactstrap";
import BasicModal from '../../../../components/Modals/BasicModal'
import { titleCase } from '../../../../utils/views/pages/Dynamics'
import { getInstitutions } from "../../../../network/ApiAxios";
import SelectInstitution from './SelectInstitution';
import secureLocalStorage from "react-secure-storage";

const GroupInformation = (props) => {
    const group = props.group
    const groupLoaded = props.groupLoaded
    const formDisabled = props.formDisabled
    const setGroup = props.setGroup
    const [showModal, setShowModal] = useState(false)
    const [warning, setWarning] = useState("")
    const [institutionOptions, setInstitutionOptions] = useState([])
    const showInstitutions = props.showInstitutions
    const setShowInstitutions = props.setShowInstitutions
    const setShowStudents = props.setShowStudents
    const setShowTeachers = props.setShowTeachers
    const setTeachersOptions = props.setTeachersOptions
    const setStudentsOptions = props.setStudentsOptions
    const validations = props.validations
    const user = JSON.parse(secureLocalStorage.getItem("user"));
    const action = props.action 

    useEffect(() => {
        // Só executar quando o grupo estiver carregado
        if (action !== "create" && !groupLoaded) {
            return;
        }
        const runAsync = async () => {
            
            let params = {
                filter: { account: user.account }
            }

            const response = await getInstitutions(params);
            const { data } = response;

            if (data.success && data.institutions.length > 0) {
                setInstitutionOptions(data.institutions)
                setShowInstitutions(true)                
            }
        }

        runAsync();

    },[groupLoaded])


    let validateField = (e) => {
        if (!e.target.value.trim() && e.target.required) {

            setWarning('The field \'' + titleCase(e.target.name) + '\' is required!')
            setShowModal(true)

        } else {
            if (validations[e.target.name] && !validations[e.target.name].test(e.target.value)) {
                setWarning('Invalid ' + titleCase(e.target.name))
                setShowModal(true)
            }
        }

    }

    let handleInput = (e) => {

        group[e.target.name] = e.target.value
        setGroup(group)

    }



    return (
        <>
            <h6 className="heading-small text-muted mb-4">
                Group information
            </h6>
            <div className="pl-lg-4">
                <Row>
                    <Col lg="6">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-name"
                            >
                                Name
                            </label>
                            <Input
                                className="form-control-alternative"
                                defaultValue={group?.name}
                                id="input-name"
                                name="name"
                                placeholder="Group Name"
                                type="text"
                                disabled={formDisabled}
                                onChange={handleInput}
                                required={true}
                                onBlur={validateField}
                            />
                        </FormGroup>
                    </Col>

                    {function () {
                                                    
                        return (

                            <Col lg="6">
                                <FormGroup>
                                    <label
                                        className="form-control-label"
                                        htmlFor="input-institution"
                                    >
                                        Institution
                                    </label>

                                    {!showInstitutions ? 
                                        <div className="text-center p-1">
                                            <Spinner size="lg"/>
                                        </div>
                                    :                              
                                        <SelectInstitution
                                            institution={group?.institution}
                                            formDisabled={formDisabled}
                                            setGroup={setGroup}
                                            institutionOptions={institutionOptions}
                                            setTeachersOptions={setTeachersOptions}
                                            setStudentsOptions={setStudentsOptions}
                                            setShowStudents={setShowStudents}
                                            setShowTeachers={setShowTeachers}
                                            group={group} />
                                    }

                                </FormGroup>
                            </Col>


                        )

                    }()
                    }

                </Row>

            </div>

            <BasicModal
                title="Warning"
                message={warning}
                showModal={showModal}
                setShowModal={setShowModal} />
        </>
    )
}

export default GroupInformation;